import BaseNormalizer from "./BaseNormalizer";

const externalOrdersNormalizer = Object.create(BaseNormalizer).init([
  "id",
  "type",
  "createdAt",
  "merchantRegion",
  "updatedAt",
  "orders.referenceCode",
  "orders.createdAt",
  "orders.netSumCents",
  "orders.vatSumsCents",
  "orders.deliveryCostCents",
  "orders.grossSumCents",
  "orders.grossSumWithDeliveryCostCents",
  "orders.merchantStoreName",
  "orders.shippingAddress",
  "orders.note",
  "orders.state",
  "orders.createdAt",
  "orders.orderItems.id",
  "orders.orderItems.amount",
  "orders.orderItems.depositValueCents",
  "orders.orderItems.name",
  "orders.orderItems.netPriceCents",
  "orders.orderItems.vat",
  "orders.orderItems.orderUnit.id",
  "orders.orderItems.orderUnit.name",
  "orders.orderItems.orderUnit.ean",
  "orders.orderItems.orderUnit.supplierArticleNumber",
  "orders.orderItems.orderUnit.orderUnitType",
  "orders.orderItems.orderUnit.sumProductCount",
  "orders.orderItems.orderUnit.products.id",
  "orders.orderItems.orderUnit.products.productVariantName",
  // Maybe better to replace this with productAttrs after @5minpause decodes the JSON in the backend
  "orders.discountsInKind.count",
  "orders.discountsInKind.product.id",
  "orders.discountsInKind.product.productVariantName",
  "orders.discountsInKind.product.images",
  "orderChannelable.contactPerson",
  "orderChannelable.createdAt",
  "orderChannelable.furtherInformation",
  "orderChannelable.id",
  "orderChannelable.orderMethod",
  "orderChannelable.orderDate",
]);

export default externalOrdersNormalizer;
